module.exports = __webpack_public_path__ + "static/img/logo-spotify.b0a5df30.svg";